import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Pipe, PipeTransform } from '@angular/core';

export class ProtocoloConsultaEmpresa extends BaseEntity {
    public id: number;
    public idProtocoloNegocio: string;
    public tipoProtocolo: string;
    public statusProtocolo: string;
    public cnpjAgente: string;
    public dataEnvio: Date;
    public usuarioEnvio: string;
    public origemProtocolo: string;
    public tamanhoConteudoEnvio: number;
    public tamanhoConteudoResposta: number;
    public conteudoRespostaContemMensagemAlerta: boolean;
    public apenasValidacao: boolean;
    public siglaAgente: string;
    public nomeAgente: string;
    public usuarioSubstituicao: string;
    public dataSubstituicao: Date;

}

export enum StatusProtocoloEmpresa {
    AGUARDANDO_VALIDACAO = 'A',
    ERRO = 'E',
    SUCESSO = 'S'
  }

  export const STATUS_PROTOCOLO_EMPRESA = [
  {
    codigo: 'A',
    label: 'Aguardando validação'
  },
  {
    codigo: 'E',
    label: 'Erro'
  },
  {
    codigo: 'S',
    label: 'Sucesso'
  }
];

export class DetalheConsultaEmpresa extends BaseEntity {
  public id: number;
  public idProtocoloNegocio: string;
  public resultado: string;
  public cnpj: string;
  public dataEnvio: Date;
  public usuarioEnvio: string;
}